/**
 * Typed shape for Clerk unsafeMetadata used across SMS features.
 *
 * Clerk stores unsafeMetadata as Record<string, unknown>.
 * This file gives it a concrete shape so consumers don't need `as any`.
 */

export interface SmsConsentMetadata {
  consented: boolean;
  timestamp: string;
  optedOutAt?: string;
  optOutMethod?: string;
}

export interface LastActivityMetadata {
  draftOrderCreated?: string;
  orderSubmitted?: string;
  quoteCreated?: string;
  quoteSent?: string;
}

export interface UserUnsafeMetadata {
  smsConsent?: SmsConsentMetadata;
  firstOrderSmsSent?: boolean;
  lastActivity?: LastActivityMetadata;
  onboarded?: string;
}

/**
 * Helper to safely extract typed unsafeMetadata from a Clerk user object.
 * Clerk's SDK types unsafeMetadata as Record<string, unknown>, so a cast
 * is unavoidable — but it happens in exactly one place.
 */
export function getUnsafeMetadata(user: { unsafeMetadata?: unknown }): UserUnsafeMetadata {
  return (user.unsafeMetadata ?? {}) as UserUnsafeMetadata;
}
